import styled from "styled-components";

export const MainCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  > div:first-child {
    border-bottom: 0;
  }
`;

export const AlertContainer = styled.div`
  display: flex;
  width: calc(100% - 24px);
  margin: 0 0 12px 12px;
  > div {
    width: 100%;
  }
`;

export const ChangesCardProWrapper = styled.div<{ hasMarginTop: boolean }>`
  ${({ hasMarginTop }) => hasMarginTop && "margin-top: 12px;"}
`;
